module.exports = __webpack_public_path__ + "img/3f_selfactualization.152e0a67.svg";